import { noteEditor_children, bs_noteEditor_children, app_noteEditor_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxNoteEditor = {
  name: "cxNoteEditor",
  desc: "笔记编辑器",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "笔记编辑器",
        group: "element",
        children: app_noteEditor_children,
        enable(params) {
          let homePageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          return params.admin && homePageBusinessFlag
        },
        sort: 70
      }
    ],
    bigScreen: [
      {
        name: "笔记编辑器",
        children: bs_noteEditor_children
      }
    ],
    portal: [
      {
        name: "笔记编辑器",
        children: noteEditor_children,
        group: "element",
        enable(params) {
          let homePageBusinessFlag = true
          if ("homePageBusinessFlag" in params && params.homePageBusinessFlag === false) {
            homePageBusinessFlag = false
          }
          return params.admin && homePageBusinessFlag
        },
        sort: 80
      }
    ]
  },
  toolbars: [
    {
      name: "cxNoteEditor",
      label: "笔记编辑器",
      comp: {
        noteEditorComponentData: () => import("./toolbars/noteEditor-options-data.vue"),
        noteEditorComponentSetting: () => import("./toolbars/noteEditor-options-setting.vue"),
        noteEditorComponentStyle: () => import("./toolbars/noteEditor-options-style.vue")
      }
    }
  ]
}

export default cxNoteEditor
